export default {
  incrementPendingRequestCount(state) {
    state.pendingRequestCount += 1;
  },
  decrementPendingRequestCount(state) {
    state.pendingRequestCount -= 1;
  },
};
